import { createApi } from '@reduxjs/toolkit/query/react'
import { API_ENDPOINTS } from 'Constants'
import {
  updateCustomerArrayData,
  updateCustomerData,
  updateCustomerPaId,
} from 'features/BobSellJourney/CbsData.slice'
import {
  IAccountDetail,
  IAuthenticatedUser,
  ICBSCustomerDetails,
  ICustomerAddress,
} from 'Models/BOB/ResponseModels'
import { IUpdateCustomerDetailsResponse } from 'Models/BOB/ResponseModels/CBS'
import {
  ICBSAssuredDetails,
  IUpdateCustomerDetails,
} from 'Models/BOB/ResponseModels/CBS/CBSCustomerDetails'
import { IGetCustomerCkycRequest, IGetCustomerCkycResponse } from 'Models/RequestModels/Life/CKyc'
import { ICreateCbsCustomerRequest } from 'Models/RequestModels/Life/CreateCbsCustomerRequest'
import { bobPartnerUrlQuery } from 'Services/baseQuery'

export const bobPartnerApi = createApi({
  reducerPath: 'bobPartnerApi',
  baseQuery: bobPartnerUrlQuery,
  endpoints: (builder) => ({
    // bobSendOtp: builder.mutation<void, { mobile: string }>({
    //   query: (data) => ({
    //     url: API_ENDPOINTS.BOB.BOB_OTP_LOGIN,
    //     method: 'POST',
    //     body: data,
    //   }),
    // }),
    // bobVerifyOtp: builder.mutation<IAuthenticatedUser, { otp: string; mobile: string }>({
    //   query: (data) => ({
    //     url: API_ENDPOINTS.BOB.BOB_OTP_VERIFY,
    //     method: 'PATCH',
    //     body: data,
    //   }),
    // }),
    imageUpload: builder.mutation<
      {
        customer_id: string
        doc_type: string
        Reference_id: string[]
        file_extension: string[]
      },
      FormData
    >({
      query: (data) => ({
        url: API_ENDPOINTS.BOB.DOC_UPLOAD,
        method: 'POST',
        body: data,
      }),
    }),
    getCBSCustomer: builder.query<
      ICBSCustomerDetails[],
      {
        value: string
        type: string
        partner: string
        journey_type?: string
      }
    >({
      query: (params) => ({
        url: API_ENDPOINTS.BOB.BOB_CBS_CUSTOMER,
        method: 'GET',
        params: params,
      }),
    }),
    getCBSCustomerPost: builder.mutation<ICBSCustomerDetails, ICreateCbsCustomerRequest>({
      query: (body) => ({
        url: API_ENDPOINTS.BOB.BOB_CBS_CUSTOMER,
        method: 'POST',
        body,
      }),
    }),
    createCustomer: builder.mutation<any, { customer_detail: ICBSCustomerDetails }>({
      query: (params) => ({
        url: API_ENDPOINTS.BOB.CREATE_CUSTOMER,
        method: 'POST',
        body: params,
      }),
      // async onQueryStarted(_, { dispatch, queryFulfilled }) {
      //   try {
      //     const { data } = await queryFulfilled
      //     dispatch(updateCustomerPaId(data.customer_id))
      //   } catch (e) {
      //     console.log(e)
      //   }
      // },
    }),
    updateDetails: builder.mutation<IUpdateCustomerDetailsResponse, IUpdateCustomerDetails>({
      query: (data) => ({
        url: API_ENDPOINTS.BOB.UPDATE_CUSTOMER_DETAILS,
        method: 'POST',
        body: data,
      }),
    }),
    updateAssuredDetails: builder.mutation<IUpdateCustomerDetailsResponse, Record<string, any>>({
      query: (data) => ({
        url: API_ENDPOINTS.BOB.UPDATE_CUSTOMER_DETAILS,
        method: 'POST',
        body: data,
      }),
    }),
    getCustomerCkyc: builder.mutation<IGetCustomerCkycResponse, IGetCustomerCkycRequest>({
      query: (data) => ({
        url: API_ENDPOINTS.BOB.GET_CUSTOMER_CKYC,
        method: 'POST',
        body: data,
      }),
    }),
  }),
})

export const {
  // useBobSendOtpMutation,
  // useBobVerifyOtpMutation,
  useLazyGetCBSCustomerQuery,
  useImageUploadMutation,
  useUpdateDetailsMutation,
  useCreateCustomerMutation,
  useGetCBSCustomerPostMutation,
  useUpdateAssuredDetailsMutation,
  useGetCustomerCkycMutation,
} = bobPartnerApi
